export default __webpack_public_path__ + "static/media/Red0005.1d15784a.png";